import React from "react";
import Index from "../../Index";

export default function BorderButton(props) {
  return (
    <>
      <Index.Box className="border-btn-main">
        <Index.Button
          className={props.className}
          type={props.type}
          onClick={props.onClick}
          disableRipple
          {...props}
          title={props.btnLabel}
        >
          <span>{props.btnLabel}</span>
        </Index.Button>
      </Index.Box>

      {/* use this button like below demo */}
      {/* <Index.PrimaryButton btnLabel="View Button"/> */}
    </>
  );
}

